import { ArrowRight } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

export function NavSignUpButton() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  return (
    <button
      onClick={() => navigate('/signup')}
      className="rounded-md border border-input px-4 py-2 text-sm font-medium text-foreground hover:bg-accent transition-colors"
    >
      {t('auth.signUp')}
    </button>
  )
}

export function HeroGetStartedButton() {
  const navigate = useNavigate()
  const { t } = useTranslation()
  return (
    <button
      onClick={() => navigate('/signup')}
      className="group flex items-center gap-2 rounded-lg bg-primary px-6 py-3 text-base font-semibold text-primary-foreground shadow-lg shadow-primary/20 hover:shadow-xl hover:shadow-primary/30 hover:-translate-y-0.5 transition-all duration-200"
    >
      {t('auth.getStarted')}
      <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
    </button>
  )
}

export function BottomGetStartedButton({ onClick }: { onClick: () => void }) {
  const { t } = useTranslation()
  return (
    <button
      onClick={onClick}
      className="group inline-flex items-center gap-2 rounded-lg bg-primary px-8 py-3.5 text-base font-semibold text-primary-foreground shadow-lg shadow-primary/20 hover:shadow-xl hover:shadow-primary/30 hover:-translate-y-0.5 transition-all duration-200"
    >
      {t('auth.getStarted')}
      <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-0.5" />
    </button>
  )
}
